import type { AppThunk } from '@app/store/store';

type RtkQuerySliceStateShape = {
  queries: unknown;
  mutations: unknown;
  provided: unknown;
  subscriptions: unknown;
  config: unknown;
};

const isRtkQuerySliceState = (sliceState: unknown): sliceState is RtkQuerySliceStateShape => {
  if (!sliceState || typeof sliceState !== 'object') {
    return false;
  }

  const candidate = sliceState as Record<string, unknown>;
  return ['queries', 'mutations', 'provided', 'subscriptions', 'config'].every((field) => field in candidate);
};

const getRtkQuerySlices = (state: Record<string, unknown>) =>
  Object.fromEntries(Object.entries(state).filter(([, sliceState]) => isRtkQuerySliceState(sliceState)));

// Reset all API states to clear all cached data. This will force the app to re-fetch data from the server.
// It will prevent cases where when a user logs in, they see the previous user's data from cache.
export const resetAllApiState = (): AppThunk => (dispatch, getState) => {
  const rtkQuerySlices = getRtkQuerySlices(getState());

  Object.keys(rtkQuerySlices).forEach((reducerPath) => {
    dispatch({ type: `${reducerPath}/resetApiState` });
  });
};
